import React from 'react'
import {css} from 'emotion'
import Box from './Box'
import renderType from './renderType'
import defaultEmptyRenderer from './defaultEmptyRenderer';

export default class DetailTable extends React.Component {

    render() {

        const {fields} = this.props

        return (
            <Box>
                <table
                className={css`
                    width: 100%;
                    table-layout: fixed;
                    border-collapse: collapse;
                `}
            >
                <tbody>
                {fields.map(field => {

                    let value = null

                    if (field.renderer) {

                        value = field.renderer({
                            value: field.value
                        })
                    } else {
                        value = renderType(field.type)({
                            value: field.value
                        })
                    }

                    return (
                        <tr
                            key={field.name}
                        >
                            <th
                                className={css`
                                    text-align: left;
                                    border-top: 1px solid #f2f2f2;
                                    border-bottom: 1px solid #f2f2f2;
                                    padding: 20px 16px;
                                    vertical-align: top;
                                    color: #737373;
                                    font-weight: 400;
                                    width: 30%;
                                `}
                                height={40}
                            >
                                {field.name}
                            </th>
                            <td
                                className={css`
                                    border-top: 1px solid #f2f2f2;
                                    border-bottom: 1px solid #f2f2f2;
                                    padding: 20px 16px;
                                `}
                                height={40}
                            >
                                {value !== null ? value : defaultEmptyRenderer()}
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            </Box>
        )
    }
}